import BaseTab from './Index.vue'

BaseTab.install = function(Vue) {
    Vue.component(BaseTab.name, BaseTab)
}

export default BaseTab
